import FJUtil from '../util/FJUtil';

const tempCanvas = document.createElement('canvas');
const tempCtx = tempCanvas.getContext('2d');
function renderFrame(ctx, frame, index, baseSize, options = {}) {
    const { width: renderWidth, height: renderHeight } = baseSize;
    const { renderInfo, sourceInfo, backgroundImageBitmap } = options;
    const dx = index * renderWidth;
    const dy = 0;
    const dWidth = renderWidth;
    const dHeight = renderHeight;
    if (renderInfo) {
        const { relativeRect, rotation, flipX, flipY, backgroundColor } = renderInfo;

        const rx = relativeRect.x * renderWidth;
        const ry = relativeRect.y * renderHeight;
        const rWidth = relativeRect.width * renderWidth;
        const rheight = relativeRect.height * renderHeight;
        let image = frame;

        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(dx, dy, dWidth, dHeight);
            ctx.restore();
        }

        ctx.save();
        ctx.translate(rx + rWidth / 2 + dx, ry + rheight / 2);
        ctx.rotate((rotation * Math.PI) / 180);
        ctx.scale(flipX, flipY);
        if (sourceInfo && sourceInfo.rotate) {
            const { rotate, width, height } = sourceInfo;
            const w = rotate === 90 || rotate === 270 ? height : width;
            const h = rotate === 90 || rotate === 270 ? width : height;
            tempCanvas.width = w;
            tempCanvas.height = h;
            changeOrientation(tempCanvas, { width, height }, rotate);
            tempCtx.drawImage(image, 0, 0);
            ctx.drawImage(tempCanvas, -rWidth / 2, -rheight / 2, rWidth, rheight);

            if (backgroundImageBitmap) {
                ctx.save();
                ctx.globalCompositeOperation = 'destination-over';
                ctx.drawImage(backgroundImageBitmap, -rWidth / 2, -rheight / 2, rWidth, rheight);
                ctx.restore();
            }
        } else {
            ctx.drawImage(image, -rWidth / 2, -rheight / 2, rWidth, rheight);

            if (backgroundImageBitmap) {
                ctx.save();
                ctx.globalCompositeOperation = 'destination-over';
                ctx.drawImage(backgroundImageBitmap, -rWidth / 2, -rheight / 2, rWidth, rheight);
                ctx.restore();
            }
        }
        ctx.restore();
    } else {
        ctx.drawImage(frame, dx, dy, dWidth, dHeight);

        if (backgroundImageBitmap) {
            ctx.save();
            ctx.globalCompositeOperation = 'destination-over';
            ctx.drawImage(backgroundImageBitmap, dx, dy, dWidth, dHeight);
            ctx.restore();
        }
    }
}

function changeOrientation(canvas, originalSize, rotation) {
    let ctx = canvas.getContext('2d');
    switch (rotation) {
        case 0:
            break;
        case 90:
            ctx.transform(0, 1, -1, 0, originalSize.height, 0);
            break;
        case 180:
            ctx.transform(-1, 0, 0, -1, originalSize.width, originalSize.height);
            break;
        case 270:
            ctx.transform(0, -1, 1, 0, 0, originalSize.width);
            break;
        default:
            return;
    }
}

async function renderThumbnails(url, canvas, options) {
    const { fileInfo, thumbnailSize, renderInfo, start, end, backgroundImageBitmap } = options;
    const ctx = canvas.getContext('2d');
    const video = document.createElement('video');
    const renderWidth = thumbnailSize.width;
    const renderHeight = thumbnailSize.height;
    const baseSize = { width: renderWidth, height: renderHeight };

    const renderCount = Math.ceil(canvas.width / renderWidth);
    const intervals = (end - start) / renderCount;

    await new Promise((resolve, reject) => {
        video.addEventListener('loadeddata', resolve);
        video.addEventListener('error', reject);
        video.src = url;
    });

    const info = {
        renderInfo,
        sourceInfo: fileInfo,
        backgroundImageBitmap,
    };

    const abortController = new AbortController();
    const signal = abortController.signal;

    // 将 abort 控制器暴露出去
    if (options.setAbortController) {
        options.setAbortController(abortController);
    }

    await (async () => {
        let time = start;
        let curRenderCount = 0;
        while (time <= end) {
            // 检查是否已被中断
            if (signal.aborted) {
                break;
            }
            await new Promise(resolve => {
                video.addEventListener('seeked', function handler() {
                    renderFrame(ctx, video, curRenderCount, baseSize, info);
                    resolve();
                    video.removeEventListener('seeked', handler);
                });
                video.currentTime = time;
            });
            curRenderCount++;
            time += intervals;
        }
    })();

    video.src = '';
}

export { renderThumbnails };
